import React from 'react'
import classNames from 'classnames'
import { type CrossClientTab, type CrossClientTabItem } from './CrossClientTabBar'
import './CrossClientLandingTabs.scss'

interface CrossClientTabButtonProps {
  tab: CrossClientTabItem
  active: boolean
  tabbable: boolean
  onSelect: (key: CrossClientTab) => void
}

export const CrossClientTabButton = React.forwardRef<HTMLButtonElement, CrossClientTabButtonProps>(({ tab, active, tabbable, onSelect }, ref) => (
  <button
    ref={ref}
    type='button'
    role='tab'
    id={`cross-client-tab-${tab.key}`}
    aria-controls='cross-client-tabpanel'
    aria-selected={active}
    tabIndex={tabbable ? 0 : -1}
    className={classNames('position-relative d-flex gap-1 align-items-center px-2 py-1 paragraph-small bold cross-client-tabs-segment-button', {
      'zocks-text-gray-900': active,
      'zocks-text-gray-600': !active,
    })}
    onClick={() => onSelect(tab.key)}
  >
    <span>{tab.label}</span>
    {tab.hideCount ? null : <span>{tab.count}</span>}
  </button>
))

CrossClientTabButton.displayName = 'CrossClientTabButton'
